import { render, staticRenderFns } from "./DiscoveryBlock.vue?vue&type=template&id=0c0ec516"
import script from "./DiscoveryBlock.vue?vue&type=script&lang=js"
export * from "./DiscoveryBlock.vue?vue&type=script&lang=js"
import style0 from "./DiscoveryBlock.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports